// extracted by mini-css-extract-plugin
export default {"PageContainer":"ForgetPasswordPage_PageContainer__8awgv","ContentContainer":"ForgetPasswordPage_ContentContainer__I8IkI"};